// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"81ae9618","990":"3af64011"}[chunkId] + ".chunk.js";
};